import { FC } from 'react'
import { usePageInfo } from '@platformui/core/infrastructure/features/page-info/page-info-hook'
import { AccessibilityNav } from '@/components/features/accessibility/accessibility-nav'

export const AccessibilityShortcuts: FC = () => {
    const {
        translations,
        pageInfo: { pageTypeName },
    } = usePageInfo()

    return (
        translations && (
            <AccessibilityNav>
                <li>
                    <a href="#content">{translations.maincontentnav}</a>
                </li>
                {pageTypeName === 'SearchPage' && (
                    <li>
                        <a href="#search">{translations.searchresultnav}</a>
                    </li>
                )}
            </AccessibilityNav>
        )
    )
}
